import { render } from "./account.vue?vue&type=template&id=46ecbc89&scoped=true"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"

import "./account.vue?vue&type=style&index=0&id=46ecbc89&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-46ecbc89"

export default script